interface SignupStepperProps {
  steps: readonly string[];
  /** 0-indexed 현재 단계 */
  current: number;
}

/**
 * 회원가입 진행 단계 표시.
 * 상단 진행바 + 단계 라벨. 완료/현재/대기 상태를 색으로 구분.
 */
export function SignupStepper({ steps, current }: SignupStepperProps) {
  const pct = ((current + 1) / steps.length) * 100;

  return (
    <div className="mb-8">
      <div className="mb-4 flex items-center justify-between">
        {steps.map((label, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <div key={label} className="flex flex-1 flex-col items-center gap-1.5">
              <span
                className={[
                  'grid h-8 w-8 place-items-center rounded-full text-[13px] font-bold transition-colors',
                  active
                    ? 'bg-brand-500 text-white'
                    : done
                      ? 'bg-brand-500/15 text-brand-600'
                      : 'bg-black/[0.06] text-neutral-950/40',
                ].join(' ')}
              >
                {done ? '✓' : i + 1}
              </span>
              <span
                className={[
                  'text-[12px] font-medium',
                  active ? 'text-neutral-950' : 'text-neutral-950/45',
                ].join(' ')}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>
      <div className="h-1 w-full overflow-hidden rounded-full bg-black/[0.06]">
        <div
          className="h-full rounded-full bg-brand-500 transition-[width] duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
